import { TextLanguage, TranslatedText } from "Store/texts/interfaces";
import {
  TractorPriceRequestInfo,
  TractorProductDetailsFormValues,
  TractorProductIntroFormValues,
} from "./tractorInterface";

import { Option } from "@storeblocks/radio";
import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { TractorCoverage } from "Store/interfaces/products/coverage";

export const TRACTOR_DEFAULT_DEDUCTIBLE = "4000";

export const getDeductible = (coverage: TractorCoverage): string => {
  if (coverage === TractorCoverage.TRACTOR_LIABILITY) {
    return "Ingen";
  }
  return TRACTOR_DEFAULT_DEDUCTIBLE;
};

export const getTractorTypeOptions = (
  options: Record<string, TranslatedText>,
  lang: TextLanguage,
): Option[] => {
  const optionIds = ["TRACTOR", "ATV_REGISTERED_AS_TRACTOR"];
  return optionIds.map((optionId) => ({
    id: optionId,
    label: options[optionId][lang],
    value: optionId,
  }));
};

export function mapFormToPriceRequest(
  formValuesIntro: TractorProductIntroFormValues,
  formValuesDetails: TractorProductDetailsFormValues,
): TractorPriceRequestInfo {
  return {
    tractorType: formValuesIntro.tractorType,
    model: formValuesIntro.brandOrModel,
    modelYear: formValuesIntro.firstRegistered,
    coverageAmount: formValuesDetails.coverageAmount,
    injuries: Number(formValuesDetails.injuries),
    injuryYear:
      formValuesDetails.injuries !== DamageRecentYears.NONE
        ? Number(formValuesDetails.injuryYear)
        : undefined,
  };
}
